var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotagIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2007 23.2895C14.8869 23.2909 13.5853 23.0412 12.368 22.5543C12.9478 22.268 13.4846 21.9041 13.9633 21.473C14.4396 21.0444 14.8531 20.5526 15.1919 20.0117C15.8939 18.8929 16.2437 17.5942 16.1971 16.2797C16.1532 15.0238 15.756 13.8046 15.0497 12.7583C14.3434 11.7119 13.3558 10.8796 12.1973 10.3542L12.1951 10.3525L12.1943 10.3499L12.1949 10.3472L12.1969 10.3452C12.9991 9.86447 13.6654 9.19228 14.1342 8.39075C14.5744 7.63573 14.825 6.78793 14.865 5.91809C14.9051 5.04824 14.7334 4.18158 14.3644 3.39039C15.6516 3.16007 16.9716 3.17389 18.2536 3.43113C19.5564 3.69389 20.7939 4.20676 21.8957 4.94049C23.533 6.02903 24.8148 7.56212 25.5858 9.35397C25.8461 9.96078 26.0449 10.5915 26.179 11.2369C26.4549 12.5709 26.4549 13.9461 26.179 15.2802C25.9122 16.5633 25.3914 17.7822 24.6464 18.867C23.5408 20.4799 21.9841 21.7423 20.1651 22.5013C19.549 22.7578 18.9087 22.9536 18.2535 23.0858C17.5779 23.2215 16.8902 23.2897 16.2007 23.2895ZM9.21126 23.2895H0.00555624L0.00346601 23.2892L0.0016719 23.288L0.000453384 23.2863L2.53809e-07 23.2843V9.38339C-0.000146444 8.76227 0.0632995 8.14272 0.189375 7.53415C0.433517 6.36033 0.909949 5.2454 1.59146 4.25303C2.60293 2.77762 4.02688 1.62285 5.69084 0.92858C6.25436 0.693951 6.84005 0.514836 7.43937 0.39385C8.05753 0.269714 8.68681 0.207262 9.31767 0.207442V0.201782C10.3801 0.202558 11.4201 0.503317 12.3145 1.06844C13.2088 1.63357 13.9204 2.4393 14.3644 3.39039C12.6205 3.70433 10.9899 4.46255 9.63549 5.58953C8.74691 6.3277 7.99249 7.20967 7.40462 8.19757C6.66947 9.43992 6.21377 10.8234 6.06838 12.2543C5.92299 13.6853 6.09129 15.1303 6.5619 16.4916C7.03251 17.8529 7.79444 19.0986 8.79612 20.1446C9.7978 21.1905 11.016 22.0125 12.368 22.5543C11.3884 23.0385 10.3072 23.2903 9.21126 23.2895Z",
    fill: "url(#paint0_linear_14238_39730)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14238_39730",
    x1: 28.5086,
    y1: -7.87892,
    x2: 1.47284,
    y2: 38.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotagIconPurple);
export default __webpack_public_path__ + "static/media/botag-icon-purple.c3685573ab4f42a86cd0b5ec6f670c05.svg";
export { ForwardRef as ReactComponent };